export default {
	phone: {
		chinese: {
			footer: {
				reference: {
					icp: '粤ICP备17093348号-2',
					icp2: '粤公网安备 44133002100104号',
					copyRight: '简单汇信息科技（广州）有限公司版权所有',
					tel: '联系电话：4008040080 （业务热线）020-87096770（邮寄专用）',
					qq: '企业QQ：800178080',
          address: '地址：广州市海珠区海洲路18号TCL大厦A座37楼',
          privacy: '个人信息及隐私保护政策'
				},
				link: {
					title: '友情链接',
					link1: '中国人民银行',
					link2: '上海票据交易所股份有限公司',
					link3: '中国互联网金融协会',
					link4: 'TCL聚采商城'
				},
				qrCode: {
					title: '二维码',
					qrCode1: '简单汇小程序',
					qrCode2: '关注公众号'
				}

			},
			backTop: {
				tel: '客服热线',
				email: '简单汇邮箱',
				qq: 'QQ客服'
			},
			nav: {
				login: '登录',
				register: '注册',
				img:require('@/images/english/i18n_en.png')
			}
		},
		english: {
			footer: {
				reference: {
					icp: 'Guangdong ICP No. 17093348-2',
					icp2: 'Guangdong Public Security Network No.44133002100104',
					copyRight: '©2017 JDH INFORMATION TECH (GUANGZHOU) CO., LTD All Rights Reserved',
					tel: 'Tel: 4008040080 (business hotline) 020-87096770 (special for mailing)',
					qq: 'Enterprise QQ: 800178080',
          address: 'Address: Room 3701, Tcl Plaza, No. 18, Haizhou Road, Haizhu District, Guangzhou',
          privacy: 'Personal Information and Privacy Policy'
				},
				link: {
					title: 'Related links',
					link1: `People's Bank of China`,
					link2: 'Shanghai Commercial Paper Exchange Corporation Ltd',
					link3: 'National Internet Finance Association of China',
					link4: 'TCL T-BUY SCM Mall'
				},
				qrCode: {
					title: 'QR code',
					qrCode1: 'JDH applet',
					qrCode2: 'Follow our WeChat official account'
				}
			},
			backTop: {
				tel: 'TEL',
				email: 'E-mail',
				qq: 'QQ'
			},
			nav: {
				login: 'Login',
				register: 'Register',
				img:require('@/images/english/i18n_zh.png')
			}
		}
	},
	pc: {
		chinese: {
			footer: {
				reference: {
					icp: '粤ICP备17093348号-2',
					icp2: '粤公网安备 44133002100104号',
					copyRight: '简单汇信息科技（广州）有限公司版权所有',
					tel: '联系电话：4008040080 （业务热线）020-87096770（邮寄专用）',
					qq: '企业QQ：800178080',
          address: '地址：广州市海珠区海洲路18号TCL大厦A座37楼',
          privacy: '个人信息及隐私保护政策'
				},
				link: {
					title: '友情链接',
					link1: '中国人民银行',
					link2: '上海票据交易所股份有限公司',
					link3: '中国互联网金融协会',
					link4: 'TCL聚采商城'
				},
				qrCode: {
					title: '二维码',
					qrCode1: '简单汇小程序',
					qrCode2: '关注公众号'
				}

			},
			backTop: {
				tel: '客服热线',
				email: '简单汇邮箱',
				qq: 'QQ客服'
			},
			nav: {
				login: '登录',
				register: '注册',
				img:require('@/images/english/i18n_en.png')
			}
		},
		english: {
			footer: {
				reference: {
					icp: 'Guangdong ICP No. 17093348-2',
					icp2: 'Guangdong Public Security Network No.44133002100104',
					copyRight: '©2017 JDH INFORMATION TECH (GUANGZHOU) CO., LTD All Rights Reserved',
					tel: 'Tel: 4008040080 (business hotline) 020-87096770 (special for mailing)',
					qq: 'Enterprise QQ: 800178080',
          address: 'Address:Room 3701, Tcl Plaza, No. 18, Haizhou Road, Haizhu District, Guangzhou',
          privacy: 'Personal Information and Privacy Policy'
				},
				link: {
					title: 'Related links',
					link1: `People's Bank of China`,
					link2: 'Shanghai Commercial Paper Exchange Corporation Ltd',
					link3: 'National Internet Finance Association of China',
					link4: 'TCL T-BUY SCM Mall'
				},
				qrCode: {
					title: 'QR code',
					qrCode1: 'JDH applet',
					qrCode2: 'Follow our WeChat official account'
				}
			},
			backTop: {
				tel: 'TEL',
				email: 'E-mail',
				qq: 'QQ'
			},
			nav: {
				login: 'Login',
				register: 'Register',
				img:require('@/images/english/i18n_zh.png')
			}
		}

	}
}



// WEBPACK FOOTER //
// ./src/utils/lang/components.js